import React, { useCallback, useMemo, useRef } from "react";

import classnames from "classnames";

import colors from "../../../assets/kits/colors";

import { AddIcon, TrashIcon, MinesIcon } from "../../kits/Icons/Icons";
import CustomButton from "../../kits/custom-button/CustomButton";

interface CartItemSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  disabled: boolean;
  cartItemCount: number;
  loading: boolean;
  disableOnClick: React.MouseEventHandler<HTMLDivElement>;
  plusOnClick: React.MouseEventHandler<HTMLButtonElement>;
  minusOnClick: React.MouseEventHandler<HTMLButtonElement>;
}

const CartItemSection: React.FC<CartItemSectionProps> = ({
  disabled,
  cartItemCount,
  loading,
  disableOnClick,
  plusOnClick,
  minusOnClick,
  className,
  style,
  onClick,
  ...props
}) => {
  const { current: squareStyle } = useRef({ width: 24, height: 24 });

  const divStyle = useMemo(() => {
    let theStyle = { ...style };
    if (disabled) {
      theStyle = { ...theStyle, cursor: "default", opacity: "0.3", zIndex: 10 };
    }
    return theStyle;
  }, [style, disabled]);

  return (
    <div
      className={classnames(
        "pc-cart",
        `pd-${loading ? "0" : "8"}`,
        {
          show: cartItemCount > 0 || loading,
        },
        className
      )}
      style={divStyle}
      onClick={
        // prevent React-Router-DOM's Link actions and do not navigate when clicking on this area
        (event) => {
          event.preventDefault();
          disabled ? disableOnClick?.(event) : onClick?.(event);
        }
      }
    >
      {loading ? (
        <CustomButton
          className="pd-0 mr-0"
          style={{ width: "100%", height: "100%", border: "none" }}
          state="loading"
        />
      ) : (
        <>
          <CustomButton
            className="pd-0 mr-0"
            icon={
              <AddIcon
                width={squareStyle.width}
                height={squareStyle.height}
                style={squareStyle}
                color={colors.schema_primary_main}
              />
            }
            style={{ pointerEvents: disabled ? "none" : "inherit" }} // not work when card is disabled
            iconPosition="center"
            buttonStyle="text"
            onClick={plusOnClick}
          />
          {cartItemCount > 0 && (
            <>
              <p className="txt-t2-m">{cartItemCount}</p>
              {cartItemCount == 1 ? (
                <CustomButton
                  className="pd-0 mr-0"
                  icon={
                    <TrashIcon
                      width={squareStyle.width}
                      height={squareStyle.height}
                      style={squareStyle}
                      color={colors.foreground_background_me}
                    />
                  }
                  style={{ pointerEvents: disabled ? "none" : "inherit" }} // not work when card is disabled
                  iconPosition="center"
                  buttonStyle="text"
                  onClick={minusOnClick}
                />
              ) : (
                <CustomButton
                  className="pd-0 mr-0"
                  icon={
                    <MinesIcon
                      width={squareStyle.width}
                      height={squareStyle.height}
                      style={squareStyle}
                      color={colors.foreground_background_me}
                    />
                  }
                  style={{ pointerEvents: disabled ? "none" : "inherit" }} // not work when card is disabled
                  iconPosition="center"
                  buttonStyle="text"
                  onClick={minusOnClick}
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default CartItemSection;
export type { CartItemSectionProps };
